import {
  ProvisionalAsset,
  ProvisionalAssetUpdate,
  wizardDataCreateResponse,
  wizardDataValidateRequest,
  wizardDataValidateResponse
} from '../../store/ProvisionalAsset';
import { ApiAdvancedFilter, PaginatedResponse } from '../../store/GeneralStore';
import { buildAdvancedQueryURL } from '../../utils/helpers';
import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const getProvisionalAsset = (id: string) => {
  return apiService.callExternalApi<ProvisionalAsset>({
    url: `${API_SERVER_URL}/provisional-assets/${id}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const listProvisionalAssets = (filters?: ApiAdvancedFilter) => {
  const mergedFilters: ApiAdvancedFilter = {
    page: 1,
    pageSize: 100,
    ...filters,
    orders: filters?.orders ?? [{ sort: 'assetNumber', direction: 'desc' }]
  };

  return apiService.callExternalApi<PaginatedResponse<ProvisionalAsset>>({
    url: buildAdvancedQueryURL(mergedFilters, 'provisional-assets'),
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const patchProvisionalAsset = (asset: ProvisionalAssetUpdate) => {
  return apiService.callExternalApi<ProvisionalAsset>({
    url: `${API_SERVER_URL}/provisional-assets/${asset.id}`,
    method: 'PUT',
    headers: {
      'content-type': 'application/json'
    },
    data: JSON.stringify(asset)
  });
};

export const bulkValidateProvisionalAssets = (data: wizardDataValidateRequest) => {
  return apiService.callExternalApi<wizardDataValidateResponse>({
    url: `${API_SERVER_URL}/provisional-assets/bulk/validate`,
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: JSON.stringify(data)
  });
};

export const bulkCreateProvisionalAssets = (data: wizardDataValidateResponse['preview']) => {
  return apiService.callExternalApi<wizardDataCreateResponse['success']>({
    url: `${API_SERVER_URL}/provisional-assets/bulk`,
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: JSON.stringify(data)
  });
};

export const bulkExportProvisionalAssets = (data: wizardDataValidateResponse) => {
  return apiService
    .callExternalApi({
      url: `${API_SERVER_URL}/provisional-assets/bulk/export`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(data),
      responseType: 'blob'
    })
    .then((res) => {
      const url = window.URL.createObjectURL(res.data as Blob);
      const link = document.createElement('a');
      link.href = url;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const contentDisposition = (res as any).headers['content-disposition'];
      let fileName = 'export.xlsx';
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="(.+)"/);
        if (match?.[1]) fileName = match[1];
      }

      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    });
};
